import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { LangService } from '../../services/lang.service';

@Component({
	selector: 'app-select-language-popover',
	templateUrl: './select-language-popover.component.html',
	styleUrls: ['./select-language-popover.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectLanguagePopoverComponent {
	public selectedLanguage: string;

	public listCountries = [
		{
			name: 'German',
			icon: '../../../assets/dean_and_david/lang/de.svg',
			value: 'de',
		},
		{
			name: 'English',
			icon: '../../../assets/dean_and_david/lang/gb.svg',
			value: 'en',
		},
		{
			name: 'Czech',
			icon: '../../../assets/dean_and_david/lang/cs.svg',
			value: 'cs',
		},
	];
	constructor(
		private popover: PopoverController,
		private translate: TranslateService,
		private langSvc: LangService
	) {
		this.selectedLanguage = this.translate.currentLang;
		this.setupKeyboardNavigation();
	}
	dismissWithData(selectedLanguage: string) {
		this.langSvc.changeLanguage(selectedLanguage);
		this.dismiss(selectedLanguage);
	}
	dismiss(data?: string) {
		this.popover.dismiss(data);
	}
	private setupKeyboardNavigation() {
		// Listen for keydown events on the popover
		setTimeout(() => {
			const popover = document.querySelector('.bsg-language-popover');
			if (!popover) return;

			popover.addEventListener('keydown', (event: KeyboardEvent) => {
				const options = Array.from(document.querySelectorAll('.bsg-language-option')) as HTMLElement[];

				if (options.length === 0) return;

				// Get the currently focused option
				const focusedOption = document.activeElement as HTMLElement;
				const currentIndex = options.indexOf(focusedOption);

				switch (event.key) {
					case 'ArrowDown':
						event.preventDefault();
						// Move focus to the next option or wrap to the first
						const nextIndex = currentIndex < options.length - 1 ? currentIndex + 1 : 0;
						options[nextIndex].focus();
						break;

					case 'ArrowUp':
						event.preventDefault();
						// Move focus to the previous option or wrap to the last
						const prevIndex = currentIndex > 0 ? currentIndex - 1 : options.length - 1;
						options[prevIndex].focus();
						break;

					case 'Escape':
						event.preventDefault();
						// Close the popover
						this.dismiss();
						break;

					case 'Home':
						event.preventDefault();
						// Move focus to the first option
						options[0].focus();
						break;

					case 'End':
						event.preventDefault();
						// Move focus to the last option
						options[options.length - 1].focus();
						break;
				}
			});
		}, 100);
	}
}
